import crewRedux from "Modules/settings/views/crew/redux/reducer";
import driverGroupsRedux from "Modules/settings/views/driverGroups/redux/reducer";
import inputLabelsRedux from "Modules/settings/views/inputLabels/redux/reducer";
import vehicleStatusRedux from "Modules/settings/views/vehicleStatus/redux/reducer";
import driverRedux from "Modules/settings/views/driver/redux/reducer";
import vehicleEquipmentRedux from "Modules/settings/views/vehicleEquipment/redux/reducer";
import keyFobsRedux from "Modules/settings/views/keyFob/redux/reducer";
import temperatureRedux from "Modules/settings/views/temperature/redux/reducer";
import unitSettingsRedux from "Modules/settings/views/unitSettings/redux/reducer";
import fuelCardRedux from "Modules/settings/views/fuelCard/redux/reducer";
import editUnitRedux from "Modules/settings/views/unitSettings/components/editUnitSettings/redux/reducer";
import driverStatusRedux from '../../views/driverStatus/redux/slice';
import driverStatusDeleteRedux from '../../views/driverStatus/components/delete/redux/slice';
import driverStatusCreateEditRedux from '../../views/driverStatus/components/createEdit/redux/slice';
import driverStatusLogListRedux from '../../views/driver/components/timeClock/redux/slice';
import driverStatusLogCreateEditRedux from '../../views/driver/components/timeClock/components/createEdit/redux/slice';
import driverStatusLogDeleteRedux from '../../views/driver/components/timeClock/components/delete/redux/slice';
import driverSliceRedux from "../../views/driver/redux/slices";
import cameraManageTabRedux from '../../views/cameraManage/redux/slice';
import cameraManageEditPairingRedux from '../../views/cameraManage/components/edit/redux/slice';
import cameraManageEditCameraRedux from '../../views/cameraManage/components/editCamera/redux/slice';
import manageCreateUpdateMetricServiceRedux from '../../views/behavior/modals/create/redux/slice';
import manageDeleteMetricServiceRedux from '../../views/behavior/modals/delete/redux/slice';
import manageBehaviorAdvanceFilterRedux from '../../views/behavior/modals/filter/redux/slice';
import manageSearchBehaviorPointsRedux from '../../views/behavior/redux/slice';
import settingsLocationsRedux from "../../views/locations/redux/slice";




export default {
    crewRedux,
    driverGroupsRedux,
    inputLabelsRedux,
    vehicleStatusRedux,
    driverRedux,
    vehicleEquipmentRedux,
    keyFobsRedux,
    temperatureRedux,
    unitSettingsRedux,
    fuelCardRedux,
    editUnitRedux,
    driverStatusRedux,
    driverStatusDeleteRedux,
    driverStatusCreateEditRedux,
    driverStatusLogListRedux,
    driverStatusLogCreateEditRedux,
    driverStatusLogDeleteRedux,
    driverSliceRedux,
    cameraManageTabRedux,
    cameraManageEditPairingRedux,
    cameraManageEditCameraRedux,
    manageCreateUpdateMetricServiceRedux,
    manageDeleteMetricServiceRedux,
    manageBehaviorAdvanceFilterRedux,
    manageSearchBehaviorPointsRedux,
    settingsLocationsRedux,
};
